export default __webpack_public_path__ + "static/media/ic-busd-bep20.5468250b.svg";